import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import MonstersList from './components/MonstersList';
import MonsterCreate from './components/MonsterCreate';
import MonsterView from './components/MonsterView';
import Encounter from './components/Encounter';
import Footer from './components/Footer';
import 'bulma/css/bulma.min.css';

function App() {
  return (
    <Router>
      <div className="container">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/monsters" element={<MonstersList />} />
          <Route path="/monsters/create" element={<MonsterCreate />} />
          <Route path="/monsters/:fileName" element={<MonsterView />} />
          <Route path="/encounter" element={<Encounter />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
